import { Component, Vue, Prop } from 'vue-property-decorator';
import { IRadarListing, INotifier } from '../../../../models/radar.listing';
import * as T_T from 'cryface';

@Component
export default class EditNotifier extends Vue {
   public title: string = 'EditNotifier';

   public status: string[] = this.fetchStatus();

   @Prop()
   public data: any;

   @Prop()
   public notifier: any;

   @Prop()
   public saveCallback: any;

   @Prop()
   public cancelCallback: any;

   @Prop()
   public index: any;

   public isShow = true;

   public async save() {
      if (this.status.indexOf('cancel') > -1) {
         this.notifier.showing_cancel = true;
      } else {
         this.notifier.showing_cancel = false;
      }
      if (this.status.indexOf('request') > -1) {
         this.notifier.showing_request = true;
      } else {
         this.notifier.showing_request = false;
      }
      if (this.status.indexOf('confirm') > -1) {
         this.notifier.showing_confirm = true;
      } else {
         this.notifier.showing_confirm = false;
      }
      if (this.status.indexOf('feedback') > -1) {
         this.notifier.showing_feedback = true;
      } else {
         this.notifier.showing_feedback = false;
      }
      await this.saveCallback(this.index, this.notifier, this.data);
   }

   public cancel() {
      this.cancelCallback();
   }

   public fetchStatus(): string[] {
      const result: string[] = [];
      const notifier: INotifier = this.notifier;
      if (notifier.showing_cancel) {
         result.push('cancel');
      }
      if (notifier.showing_request) {
         result.push('request');
      }
      if (notifier.showing_confirm) {
         result.push('confirm');
      }
      if (notifier.showing_feedback) {
         result.push('feedback');
      }
      return result;
   }

}
